<template>
  <header class="header fixed-top">
    <nav class="navbar" :class="$store.state.fullScreenNav ? 'expanded' : ''">
      <div class="base-bar">
        <router-link to="/" class="logo">
          <img src="/white-logo.png" />
          <span class="spacer"></span>
          <span>PanelVue</span>
        </router-link>

        <button class="btn menu my-auto" @click="toggleMenu">
          <i class="fa fa-bars"></i>
        </button>
        <div class="actions my-auto">
          <logout-button class="logout-button"></logout-button>
        </div>
      </div>

      <transition name="menu-fade">
        <NavMenu :isFullScreen="true" v-if="$store.state.fullScreenNav" />
      </transition>
    </nav>
  </header>
</template>
<script>
import NavMenu from "@/layouts/NavMenu.vue";

import LogoutButton from "@/components/LogoutButton";

export default {
  name: "navheader",
  components: {
    LogoutButton,
    NavMenu,
  },
  data() {
    return {
      name: "",
      user: {},
    };
  },
  methods: {
    toggleMenu() {
      this.$store.commit("toggleFullScreenNav");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./css/customvariables";

.full-screen-nav {
  position: absolute;
  left: 0;
  top: 64px;
  height: 100%;

  width: 100%;
  background: #ddd;
}

.menu {
  color: white;
  margin: 10px;
  border: 1px solid white;
}

.actions {
  line-height: 1;
}

.menu-fade-enter-active {
  transition: opacity 0.3s ease;
}
.menu-fade-leave-active {
  transition: opacity 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.menu-fade-enter,
.menu-fade-leave-to {
  opacity: 0;
}

@media screen and (min-width: 769px) {
  .menu {
    display: none;
  }

  .full-screen-nav {
    display: none;
  }
}

@media screen and (max-width: 768px+1px) {
  .actions {
    display: none;
  }
}

.logout-button {
  margin-right: 10px;
}

.spacer {
  padding-right: 10px;
}

.header {
  z-index: 1030;

  .navbar {
    margin-bottom: 0;
    height: 64px;
    background: $header_color;
    background-size: 100% 100%;
    box-shadow: 0px 0px 5px black;

    .base-bar {
      height: 100%;
      padding-left: 24px;
      padding-right: 24px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .navbar-right {
    float: right;
    margin-right: 15px;
  }

  .logo {
    display: flex;
    text-align: center;
    background: $header_color;

    height: 100%;
    justify-content: center;
    align-items: center;

    font-size: 14pt;
    color: white;

    img {
      height: 1em;
    }
  }

  .navbar-right {
    .dropdown-item {
      padding: 0;
      width: 100%;
      outline: none;
    }
  }
}

/* Fix menu positions on xs screens to appear correctly and fully */
@media (max-width: 768px) {
  body .header,
  body .header nav {
    width: 100%;
  }
  body .header nav .sidebar-toggle {
    padding-left: 15px;
  }
  nav {
    // height: 100px !important;

    transition: height 0.25s;
  }
}

.notifications_badge_top {
  margin-top: -28px;
  margin-left: 10px;
  position: absolute;

  span {
    top: 1px;
    left: 2px;
    border-radius: 50%;
    font-size: 9px;
    padding: 0.23em 0.45em;
  }
}

.notifications-menu .dropdown-item {
  width: 100%;
  display: block;
}

.dropdown-footer {
  padding: 10px !important;
}
</style>

<style type="text/css" lang="scss">
@import "./css/customvariables";

.wrapper {
  margin-top: 50px;
}

.tabs_cont,
.event_date {
  background-color: #fff !important;
}

body.left-hidden aside.right-aside {
  margin-left: 0;
}

body.left-hidden .header.fixed-top {
  padding-right: 0 !important;
}
</style>
